import { normalizeString } from '@/utils/stringUtils';
import type { VacationPeriod } from './collaborator.types';

const SELL_PATTERN = /\b(abono|pecuni)/;
const NEGATED_SELL_PATTERN = /\bnao\s+(\w+\s+){0,2}(abono|pecuni)|\bsem\s+(\w+\s+){0,2}(abono|pecuni)/;

export function mentionsSellInObservation(observations: string | null | undefined): boolean {
    const text = normalizeString(observations);
    return SELL_PATTERN.test(text) && !NEGATED_SELL_PATTERN.test(text);
}

export function normalizeVacationPeriods(periods: VacationPeriod[] | null | undefined): VacationPeriod[] {
    return (periods ?? []).map((period) => {
        if (period.hasSellDays !== undefined) return period;
        if (!mentionsSellInObservation(period.observations)) return period;

        return { ...period, hasSellDays: true };
    });
}
